import styles from './LoginFormInput.module.css';
import TextField from '@material-ui/core/TextField';

export const LoginFormInput = ({
    onChange,
    id,
    children,
    type,
    value,
}) => (
    <TextField
        className={styles.authFormInput}
        id={id}
        label={children}
        variant='outlined'
        type={type}
        fullWidth
        onChange={onChange}
        value={value}
        size='medium'
    />
);

